const BreakStatement = {
  print: () => 'break;'
};

module.exports = BreakStatement;
